import request from "@/utils/request";
import {apiConfig} from "@/config/api";

export function getData(params) {
  return request({
    url: apiConfig.examStatistics.api.data.url,
    method: "get",
    params
  });
}

export function getPager(data) {
  return request({
    url: apiConfig.examStatistics.api.pager.url,
    method: "post",
    data
  });
}

export function getAllAgent(params) {
  return request({
    url: apiConfig.examStatistics.api.getAllAgent.url,
    method: "get",
    params
  });
}
export function exportPager(data) {
  return request({
    url: apiConfig.examStatistics.api.exportPager.url,
    method: 'post',
    data,
    responseType: "blob"
  });
}
